/**
 * objectにプロパティが存在するかどうか
 * @param object
 */
export function existProperty(object: Record<string, unknown>) {
  if (isObject(object)) {
    return Object.keys(object).length > 0;
  }
  return false;
}

/**
 * existPropertyNumbers
 * @param props
 */
export const existPropertyNumbers = (props: Record<string, unknown>) => {
  let num = 0;
  Object.values(props).forEach((v) => {
    if (v) num += 1;
  });
  return num;
};

/**
 * isObject
 * @param value
 */
export function isObject(value: unknown) {
  return value !== null && typeof value === 'object';
}

/**
 * objectからnullableなvalueをもつプロパティ削除する
 * @param obj
 * @returns
 */
export const removeUndefinedFromObject = <T>(obj: { [key: string]: T }) =>
  Object.fromEntries(
    Object.entries(obj).filter(([, v]) => v !== undefined && v !== null)
  );
